import React from "react";
import styled from 'styled-components';
import { Grommet, Button, Image, Text} from "grommet";
import PropTypes from 'prop-types';



const StyledButton = styled(Button)`
    .button:hover{
        box-shadow:'rgb(186, 36, 255) 0px 0px 2px 2px';
    }
`
const SecondaryButton = ({
    label,
    url,
    icon
}) => {
    const secondryBoxStyle ={
        global: {
            colors:{
                focus:'rgb(186, 36, 255)'
            }
        },
        button: {
            color:'white',
            font:{
                weight:200
            },
            border: {
                radius: undefined,
                color: 'rgba(255, 255, 255, 0.33)',
                width: '1px',
                hover: {
                    shadow:{color:'rgb(186, 36, 255)'}
                }
            },
            
        }

    };

    console.log(url,icon);
    return (
        <Grommet theme={secondryBoxStyle}>
            <StyledButton
                //style={{hover:{}}
                className="button"
                //color={"white"}
                size="medium"
                gap="xsmall"
                margin={"auto"}
                href={url}
                target="_blank"
                label={
                <Text weight={"lighter"}>{label}</Text>
            }
                icon={
                    <Image width="25px" fit="contain" src={icon}></Image>
                }
                reverse={true}>
                </StyledButton>
        </Grommet>
        
            
       
    );
}
SecondaryButton.prototype = {
    url:PropTypes.string,
    icon:PropTypes.string,
}
export { SecondaryButton };